import { combineReducers } from "redux";
import loaderReducer from "./LoaderSlice";
import settingsReducer from "./SettingsSlice";
import userAuthenticationReducer from "./UserAuthenticationSlice";
import commonDataReducer from "./CommonSlice";
import partnerDashboardReducer from "./PartnerDashboardSlice";
import adminProductsReducer from "./AdminProductsSlice";
import momListReducer from "./MOMSlice";
import interactiveMapsReducer from "./InteractiveMapsSlice";
import partnerComplianceLetterReducer from "./PartnerComplianceLetterSlice";
import partnerInvoiceReducer from "./PartnerInvoiceSlice";
import royaltySalesReducer from "./RoyaltySalesSlice";
import filingPlansReducer from "./FilingPlansSlice";
import { api } from "../api/apiSlice";
// Note: Leave the existing imported reducers until they're all migrated
// import Common from "./Common"; // Migrated to CommonSlice
// import AdminProducts from "./AdminProducts"; // Migrated to AdminProductsSlice
import AdminPartner from "./AdminPartner";
// import PartnerDashboard from "./PartnerDashboard"; // Migrated to PartnerDashboardSlice
import ProductDevelopmentTimeline from "./ProductDevelopmentTimeline";
// import FilingPlans from "./FilingPlans"; // Migrated to FilingPlansSlice
import SalesReport from "./SalesReport";
// import UserAuthentication from "./UserAuthentication"; // Migrated to UserAuthenticationSlice
import AdminDashboard from "./AdminDashboard";
import AdminComplianceTemplate from "./AdminTemplate";
import PartnerCompliance from "./PartnerCompliance";
// import PartnerComplianceLetter from "./PartnerComplianceLetter"; // Migrated to PartnerComplianceLetterSlice
// import MOMList from "./MOM"; // Migrated to MOMSlice
// import InteractiveMaps from "./InteractiveMaps"; // Migrated to InteractiveMapsSlice
// import RoyaltySales from "./RoyaltySales"; // Migrated to RoyaltySalesSlice
// import PartnerInvoice from "./PartnerInvoice"; // Migrated to PartnerInvoiceSlice

const rootReducer = combineReducers({
  settings: settingsReducer,
  loader: loaderReducer,
  authentication: userAuthenticationReducer,
  commonData: commonDataReducer,
  partnerDashboard: partnerDashboardReducer,
  adminProducts: adminProductsReducer,
  momList: momListReducer,
  interactiveMaps: interactiveMapsReducer,
  partnerComplianceLetter: partnerComplianceLetterReducer,
  partnerInvoice: partnerInvoiceReducer,
  royaltySales: royaltySalesReducer,
  filingPlans: filingPlansReducer,
  [api.reducerPath]: api.reducer,
  // commonData: Common, // Replaced with commonDataReducer above
  // authentication: UserAuthentication, // Replaced with userAuthenticationReducer above
  // partnerDashboard: PartnerDashboard, // Replaced with partnerDashboardReducer above
  // adminProducts: AdminProducts, // Replaced with adminProductsReducer above
  // momList: MOMList, // Replaced with momListReducer above
  // interactiveMaps: InteractiveMaps, // Replaced with interactiveMapsReducer above
  // partnerComplianceLetter: PartnerComplianceLetter, // Replaced with partnerComplianceLetterReducer above
  // partnerInvoice: PartnerInvoice, // Replaced with partnerInvoiceReducer above
  // royaltySales: RoyaltySales, // Replaced with royaltySalesReducer above
  // filingPlans: FilingPlans, // Replaced with filingPlansReducer above
  adminPartner: AdminPartner,
  pdt: ProductDevelopmentTimeline,
  salesReport: SalesReport,
  adminDashboard: AdminDashboard,
  adminCompliance: AdminComplianceTemplate,
  partnerCompliance: PartnerCompliance,
});

export default rootReducer;
